import { Stack, Typography } from '@mui/material';
import { Collapse } from 'framework/ui/mui-builder';
import type { FieldElement } from '../../format/form-definition';
import { useBuilder } from '../context';
import { DrawerSection } from '../drawer/DrawerSection';
import { ruleKindsOf, validationOf } from '../validation/rules';
import { RequiredRule } from '../validation/RequiredRule';
import { UniqueRule } from '../validation/UniqueRule';
import { useState } from 'react';
import { PatternRule } from '../validation/PatternRule';
import { RangeRule } from '../validation/RangeRule';

export const ValidationSection = ({ field }: { field: FieldElement }) => {
  const { form } = useBuilder();
  const [advancedOpen, setAdvancedOpen] = useState(() => validationOf(field, 'pattern') !== undefined);
  const ruleKinds = ruleKindsOf(form, field);
  return (
    <DrawerSection
      sections={[
        {
          id: 'validation',
          title: 'Validation',
          content: (
            <Stack useFlexGap spacing={2.5}>
              {ruleKinds.includes('required') && <RequiredRule field={field} />}
              {ruleKinds.includes('range') && <RangeRule field={field} />}
              {ruleKinds.includes('unique') && <UniqueRule field={field} />}
              {ruleKinds.includes('pattern') && (
                <Collapse
                  header={<Typography component="span">Advanced</Typography>}
                  isExpanded={advancedOpen}
                  toggle={() => setAdvancedOpen(open => !open)}
                >
                  <PatternRule field={field} />
                </Collapse>
              )}
            </Stack>
          ),
        },
      ]}
    />
  );
};
